import { FormField } from "../../../FormEngine/types";
import FamilyList from "./FamilyList";
import { familySchema } from "./validation";





// import { familyHistoryData } from "../../../../constants/patientForms";

/**
 * Family History form schema
 * 
 * This schema defines the fields for the Family History form
 * using the FormEngine component.
 */
export const familyHistorySchema: FormField[] = [
  {
    type: "group-input",
    name: "familyMedicalConditions",
    title: "Family Sleep History",
    description:
      "Do any of your immediate family members have sleep disorders including sleep apnea, insomnia or narcolepsy?",
    group: [
      {
        type: "radio",
        name: "badSleep.response",
        fieldProps: {
          options: [
            { label: "Yes", value: true },
            { label: "No", value: false },
          ],
          sx: { flexDirection: "row", gap: 1 },
        },
      },
      {
        type: "input",
        name: "badSleep.description",
        label: "Description",
        conditional: {
          label: "badSleep.response",
          values: [true],
        },
      },
    ],
    fieldProps: {
      direction: "column",
    },
  },
  {
    type: "custom",
    name: "familyMedicalConditions",
    component: FamilyList,
    title: "Family Medical Conditions",
    description: "Please list all family members with medical conditions",
  },
];

export default familyHistorySchema;